"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleValidators = exports.defaultValidators = void 0;
var validationUtils_1 = require("../../../youwell-common/validationUtils");
var constants_1 = require("../../../youwell-common/constants");
exports.defaultValidators = {
    fnr: validationUtils_1.validateFnr,
    email: validationUtils_1.validateEmail,
    userLevel: validationUtils_1.validateRequired,
    newPassword: validationUtils_1.validatePassword,
    newPasswordConfirm: validationUtils_1.validatePasswordConfirm,
};
var getRuleValidators = function (userLevel) {
    switch (userLevel) {
        case constants_1.patientUserLevels.none: {
            return {
                userLevel: validationUtils_1.validateRequired,
                name: validationUtils_1.validateRequired,
                fnr: validationUtils_1.validateFnr,
                email: validationUtils_1.validateEmail,
            };
        }
        case constants_1.patientUserLevels.anonymous: {
            return {
                userLevel: validationUtils_1.validateRequired,
                username: validationUtils_1.validateRequired,
                newPassword: validationUtils_1.validatePassword,
                newPasswordConfirm: validationUtils_1.validatePasswordConfirm,
            };
        }
        case constants_1.patientUserLevels.person: {
            return {
                userLevel: validationUtils_1.validateRequired,
                name: validationUtils_1.validateRequired,
                email: [validationUtils_1.validateEmail, validationUtils_1.validateRequired],
                newPassword: validationUtils_1.validatePassword,
                newPasswordConfirm: validationUtils_1.validatePasswordConfirm,
            };
        }
        case constants_1.patientUserLevels.patient: {
            return {
                userLevel: validationUtils_1.validateRequired,
                name: validationUtils_1.validateRequired,
                fnr: [validationUtils_1.validateFnr, validationUtils_1.validateRequired],
                email: validationUtils_1.validateEmail,
            };
        }
        default: {
            return exports.defaultValidators;
        }
    }
};
exports.getRuleValidators = getRuleValidators;
